import { render } from "./ForgotPasswordBody.vue?vue&type=template&id=151192fa&scoped=true"
import script from "./ForgotPasswordBody.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordBody.vue?vue&type=script&lang=js"

import "./ForgotPasswordBody.vue?vue&type=style&index=0&id=151192fa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151192fa"]])

export default __exports__